import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_341: DocMigration = {
  maxSchemaVersion: "0.0.341",
  description: "Correct mismatches between optionSet/option IDs/parentIds and the table keys.",
  apply(json: any) {
    for (const optionSetKey in json.optionSets) {
      const optionSet = json.optionSets[optionSetKey];

      // Fix ID
      if (optionSet.id !== optionSetKey) {
        optionSet.id = optionSetKey;
      }

      for (const optionKey in optionSet.options) {
        const option = optionSet.options[optionKey];

        // Fix ID
        if (option.id !== optionKey) {
          option.id = optionKey;
        }

        // Fix parentId
        if (option.parentId !== optionSetKey) {
          option.parentId = optionSetKey;
        }
      }
    }

    return json;
  },
};

export default migration_0_0_341;
